import { LBtn, LHero, LSubTitle, LTitle } from "@components";
import { NavItems } from "@helpers/navigation";
import { useLocation, useNavigate } from "react-router";

export const ContactConfirm = (): JSX.Element => {
    const { state } = useLocation();
    const navigate = useNavigate();

    const handleOnGo = async (): Promise<void> => {
        if (state.hasUser) {
            navigate(NavItems.Admin.Manage.Overview.path);
        } else {
            // TODO: use Lassi-D url
            location.href = "https://i-function.com/lassi-l";
        }
    };

    return (
        <LHero contentCentered centered>
            <div className="box p-6 px-6 mt-6">
                <LTitle>Thank you!</LTitle>
                <LSubTitle className="mt-4" size="5">
                    Your custom purchase request has been successfully submitted!
                </LSubTitle>
                <LSubTitle size="6">Our sales team member will be in touch with you in 1-2 business days.</LSubTitle>
                <div className="mw-70 pt-4">
                    <LBtn type="button" isLarge onClick={handleOnGo} fullWidth isBold>
                        Back to LASSI-D™ Page
                    </LBtn>
                </div>
            </div>
        </LHero>
    );
};
